import { BaseRequest } from './BaseRequest';

export class OverviewRequest extends BaseRequest {
    PaymentAccount: string;
}